import { Hidden } from "@material-ui/core";

import styles from "./MobileMenuToggler.module.scss";

export const MobileMenuToggler = (): JSX.Element => (
  <Hidden smUp>
    <button className={styles.toggler}>
      <span className={styles.hamburger}></span>
      <span className={styles.label}>Menu</span>
    </button>
  </Hidden>
);
